export class IT {
    getTranslations() {
        return {
            btn_validate: 'Conferma',
            btn_cancel: 'Annulla',
            btn_close: 'Chiudi',
            btn_add: 'Aggiungi',
            btn_delete: 'Elimina',
            msg_alert: 'Avviso',
            msg_success: 'Riuscito',
            msg_confirm: 'Conferma',
            msg_input: 'Inserimento',
            datahub_pickup_indicator: 'Scegli indicatori',
            datahub_fields: 'Campi',
            config_menu_loading: 'Caricamento menu...',
            editable_label_edit: 'Modifica',
            editable_label_validate: 'Convalida modifica',
            please_wait: 'Attendi...',
            combobox_placeholder: "Seleziona un'opzione",
            card_button_start: 'Iniziare',
            enter_credentials_to: 'Inserisci le tue credenziali per accedere a ',
        };
    }
}
